const initialState: Redux.VendorImpressions = {
	currentTimeout: undefined,
	directoryStyle: undefined,
	impressionQueue: [],
};

export default initialState;
